// extracted by mini-css-extract-plugin
export default {"card":"headerCard_card__9ozGv","header":"headerCard_header__TC9HL","icon":"headerCard_icon__lEdQ9"};